<template>
<div class="chapter">
<div class="inner_page">
<p class="ded-head"><i>Dedication</i></p>
<p class="ded">To my favorite people to celebrate—my family</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_dedication.vue?1e02cd5f